import { apiClient } from './client';
import { Board } from '../types/board';

export async function fetchBoards(): Promise<Board[]> {
  const { data } = await apiClient.get<Board[]>('/boards');
  return data;
}

export async function createBoard(boardName: string): Promise<Board> {
  const { data } = await apiClient.post<Board>('/boards', { boardName });
  return data;
}

export async function renameBoard(boardId: number, boardName: string): Promise<Board> {
  const { data } = await apiClient.patch<Board>(`/boards/${boardId}`, { boardName });
  return data;
}

export async function deleteBoard(boardId: number): Promise<void> {
  await apiClient.delete(`/boards/${boardId}`);
}
